import React, { useState } from 'react';

const OneGiftLogoSquare = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div 
      style={{ 
        position: 'relative',
        display: 'inline-block',
        margin: '0px',
        cursor: 'pointer',
        paddingBottom: '80px' // Space for tooltip below
      }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <a 
        href="https://onegiftfoundation.org" 
        target="_blank"
        rel="noopener noreferrer"
      >
        <img 
          src="https://onegiftfoundation.org/hubfs/OneGift%20Logo.ico" 
          alt="OneGift Foundation Logo" 
          style={{
            width: '24px',
            height: '24px',
            filter: showTooltip ? 'brightness(1)' : 'brightness(0.9)',
            transition: 'filter 0.3s ease'
          }}
        />
      </a>
      <div style={{
        position: 'absolute',
        top: '40px',
        right: '12px', // Position from right instead of left
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        color: 'white',
        padding: '10px',
        borderRadius: '6px',
        width: '300px',
        textAlign: 'center',
        fontSize: '14px',
        zIndex: 1000,
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        backdropFilter: 'blur(5px)',
        opacity: showTooltip ? 1 : 0,
        visibility: showTooltip ? 'visible' : 'hidden',
        transition: 'opacity 0.2s, visibility 0.2s',
        pointerEvents: showTooltip ? 'auto' : 'none'
      }}>
        <div style={{
          position: 'absolute',
          top: '-20px',
          left: 0,
          width: '100%',
          height: '20px',
          background: 'transparent'
        }} />
        Audioread donates 10% of our sales to OneGift, a 501c3 committed to empowering generosity with technology. Audioread users can choose where our donations go by signing up.{' '}
        <a 
          href="https://onegiftfoundation.org" 
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#4292fa', textDecoration: 'underline' }}
        >
          Learn more
        </a>
      </div>
    </div>
  );
};

export default OneGiftLogoSquare;